//
//
//
//
//
//

import configList from '@/components/FormGenerator/index/Home.vue';
export default {
  components: {
    configList: configList
  },
  // name: "configList",
  props: {
    prentData: {
      type: Object,
      default: {}
    }
  }
};